import produce from 'immer';

import { THIS_MONTH } from '@constants/Kendo/rangeOptions';

import {
  actionTypes as dateRangePickerActionTypes,
  buildInitialState as buildInitialDateRangeState,
  reducerValuesFunction as dateRangePickerReducerFunction
} from '@components/Kendo/DateRangePickerReducer';

export const actionTypes = {
  FILTER_CHANGED: 'FILTER_CHANGED',
  FILTER_TOGGLED: 'FILTER_TOGGLED',
  FILTERS_RESET: 'FILTERS_RESET',
  DATA_LOADED: 'DATA_LOADED',
  IS_LOADING: 'IS_LOADING',
  LOAD_FILTERS_FROM_CACHE: 'LOAD_FILTERS_FROM_CACHE',
  ...dateRangePickerActionTypes // static line, should be the only one for all DateRangePickers
};

export const buildInitialFiltersState = () => {
  return {
    values: {
      account: '',
      building: '',
      territory: '',
      technician: '',
      technicianTeam: '',
      invoiceCategory: '',
      ...buildInitialDateRangeState('issueDate', THIS_MONTH)
    },
    active: {
      account: true,
      building: true,
      territory: true,
      technician: false,
      technicianTeam: false,
      invoiceCategory: false,
      issueDate: true
    }
  };
};

export const reducer = produce((state, action) => {
  // static snippet, should be the only one for all DateRangePickers
  if (Object.keys(dateRangePickerActionTypes).includes(action.type)) {
    return dateRangePickerReducerFunction(state, action);
  }

  switch (action.type) {
    case actionTypes.FILTERS_RESET:
      state.filters = buildInitialFiltersState();
      break;
    case actionTypes.FILTER_CHANGED:
      if (action.value === state.filters.values[action.field]) break;

      state.isLoading = true;
      state.filters.values[action.field] = action.value;
      break;
    case actionTypes.FILTER_TOGGLED:
      state.filters.values[action.field] = '';
      state.filters.active[action.field] = !state.filters.active[action.field];
      break;
    case actionTypes.DATA_LOADED:
      state.isLoading = false;
      state.totalInvoiced = action.data.totalInvoiced;
      state.totalDue = action.data.totalDue;
      state.outstandingCustomers = action.data.outstandingCustomers;
      state.issueHistory = action.data.issueHistory;
      state.historyByTech = action.data.historyByTech;
      state.paidHistory = action.data.paidHistory;
      state.months = action.data.months;
      break;
    case actionTypes.IS_LOADING:
      state.isLoading = true;
      break;
    default:
      throw new Error('Reducer - Wrong action type.');
  }
});
